import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { IEmergencyEvacuationKit } from '../models/emergencyEvacuationKit';
import { ErrorService } from '../helpers/errorService';

@Injectable({
    providedIn: 'root'
})
export class EmergencyEvacuationKitsService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    getEmergencyEvacuationKits(buildingId: string): Observable<{has_error: boolean, message: string, data: IEmergencyEvacuationKit[]}> {
        const url = environment.apiBaseUrl + endpoints.getEmergencyEvacuationKits.replace(':buildingId', buildingId);
        return this.http.get<{has_error: boolean, message: string, data: IEmergencyEvacuationKit[]}>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    createEmergencyEvacuationKit(buildingId: string, data: Partial<IEmergencyEvacuationKit>): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.createEmergencyEvacuationKit.replace(':buildingId', buildingId);
        return this.http.post<{has_error: boolean, message: string, data: any}>(url, data).pipe(
            catchError(this.errorService.handleError)
        );
    }

    updateEmergencyEvacuationKit(buildingId: string, itemId: string, data: Partial<IEmergencyEvacuationKit>): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.updateEmergencyEvacuationKit
            .replace(':buildingId', buildingId)
            .replace(':itemId', itemId);
        return this.http.put<{has_error: boolean, message: string, data: any}>(url, data).pipe(
            catchError(this.errorService.handleError)
        );
    }

    deleteEmergencyEvacuationKit(buildingId: string, itemId: string): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.deleteEmergencyEvacuationKit
            .replace(':buildingId', buildingId)
            .replace(':itemId', itemId);
        return this.http.delete<{has_error: boolean, message: string, data: any}>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }
}
